import * as fabric from 'fabric';
import { SnappableMixin } from './snappable';

export class SnappyGroup extends SnappableMixin(fabric.Group) {}
